import { DealerProps } from "../../store/modules/DealerCare/types.store";
import { MerchantInfo } from "services/paymentApi";
import type { Provider } from "./components/DealerAcquirersTable/types";

export interface LocalPaymentProviderData {
  id: string;
  methods: string[];
  creditBrands: string[];
  debitBrands: string[];
}

export interface ProcessedProvider {
  id: string;
  name: string;
  code: string;
  schema: string;
}

interface RawProvider {
  id: string;
  name: string;
  code: string;
  schema?: string | Record<string, unknown>;
  methods?: string[];
  acquirer?: {
    debitBrands?: string[];
    creditBrands?: string[];
  };
  type?: string;
}

export function normalizeProviderSchemaToJsonString(schema: unknown): string {
  if (typeof schema === "string") {
    return schema;
  }
  if (schema && typeof schema === "object") {
    try {
      return JSON.stringify(schema);
    } catch {
      return "";
    }
  }
  return "";
}

export function extractLocalPaymentData(
  provider: Provider | null | undefined,
): LocalPaymentProviderData | null {
  if (!provider) return null;

  const { acquirer } = provider;

  return {
    id: provider.id,
    methods: provider.methods ?? [],
    creditBrands: acquirer ? acquirer.creditBrands ?? [] : [],
    debitBrands: acquirer ? acquirer.debitBrands ?? [] : [],
  };
}

export function sanitizeProviders(
  providers: RawProvider[],
): ProcessedProvider[] {
  return providers.map((provider) => ({
    id: provider.id,
    name: provider.name,
    code: provider.code,
    schema: normalizeProviderSchemaToJsonString(provider.schema),
  }));
}

export function mergeDealerDataWithMcc(
  dealerData: DealerProps | null,
  merchantInfo: MerchantInfo["data"] | null,
): DealerProps | null {
  if (!dealerData) return null;

  const categoryCode = merchantInfo?.categoryCode;
  const mccValue =
    categoryCode && categoryCode !== "0" && Number(categoryCode) !== 0
      ? categoryCode
      : undefined;

  return {
    ...dealerData,
    ...(mccValue !== undefined && { mcc: mccValue }),
  } as DealerProps;
}
